import type { RouteLocationNormalized, Router } from "vue-router";

export const recruitmentHiringRouteName = {
  index: "recruitment-hiring.index",
  show: "recruitment-hiring.show",
};

export const recruitmentHiringRoute = [
  {
    path: "/recruitment-hiring",
    name: recruitmentHiringRouteName.index,
    component: () => import("../pages/DataTablePage.vue"),
    meta: {
      requiresAuth: true,
      layout: "adminSidebar",
      menu: "recruitment_hiring",
      breadcrumbs: () => {
        return [{ title: "Recruitment Hiring" }];
      },
    },
  },
  {
    path: "/recruitment-hiring/:id",
    name: recruitmentHiringRouteName.show,
    component: () => import("../pages/DetailPage.vue"),
    meta: {
      requiresAuth: true,
      layout: "adminSidebar",
      menu: "recruitment_hiring",
      breadcrumbs: (_to: RouteLocationNormalized, router: Router) => {
        return [{ path: router.resolve({ name: recruitmentHiringRouteName.index }).path, title: "Recruitment Hiring" }, { title: "Detail" }];
      },
    },
  },
];
